import { Box, LinearProgress } from '@material-ui/core';

export const LoadingComponent = () => (
  <Box width="100%" height="10px">
    <LinearProgress color="secondary" />
  </Box>
);
